import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47ece677"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开始新对话", -1));
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = {
  class: "logList"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0,
  class: "chatTime"
};
const _hoisted_6 = {
  class: "chatItem"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "middle-dot"
}, "·", -1));
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 1,
  class: "empty-box"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "无对话", -1));
const _hoisted_12 = {
  class: "userList"
};
const _hoisted_13 = {
  class: "userBox"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "userBox"
};
const _hoisted_16 = {
  class: "userBox-text"
};
const _hoisted_17 = {
  class: "feedback"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = ["href"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vertical-line"
}, "|", -1));
const _hoisted_21 = {
  class: "betaBox"
};
const _hoisted_22 = {
  class: "logoBox"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "梅斯小智", -1));
const _hoisted_25 = ["src"];
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  style: {
    "padding": "0 15px"
  }
};
const _hoisted_28 = {
  id: "scrollbar"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  class: "newBox"
};
const _hoisted_31 = ["innerHTML"];
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h2",
  style: {
    "font-size": "14px"
  }
}, " 能学习和理解人类的语言，能回答你医疗相关的问题 ", -1));
const _hoisted_33 = {
  key: 0,
  class: "qTemplate"
};
const _hoisted_34 = {
  class: "qContent"
};
const _hoisted_35 = {
  class: "qTop"
};
const _hoisted_36 = {
  class: "keyWord"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["src"];
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "editBtn"
}, "编辑执行", -1));
const _hoisted_40 = ["innerHTML"];
const _hoisted_41 = {
  key: 1,
  class: "box"
};
const _hoisted_42 = {
  key: 0,
  class: "contextStyle1"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = ["innerHTML"];
const _hoisted_45 = {
  key: 1,
  class: "contextStyle2"
};
const _hoisted_46 = ["src"];
const _hoisted_47 = ["innerHTML"];
const _hoisted_48 = {
  class: "footer"
};
const _hoisted_49 = ["placeholder", "readonly"];
const _hoisted_50 = ["disabled"];
const _hoisted_51 = ["src"];
const _hoisted_52 = ["disabled"];
const _hoisted_53 = ["src"];
const _hoisted_54 = {
  style: {
    "text-align": "center",
    "position": "relative"
  }
};
const _hoisted_55 = {
  class: "footer_box"
};
const _hoisted_56 = {
  class: "change_background",
  style: {
    "position": "absolute"
  }
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "柔和模式", -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "right",
    "margin-right": "23px"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "linkStyle"
}, [/*#__PURE__*/_createTextVNode(" 仅供学习使用，使用前请知晓 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.medsci.cn/about/index.do?id=14",
  target: "_blank"
}, " 免责声明 ")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_left = _resolveComponent("left");
  const _component_Popup = _resolveComponent("Popup");
  const _component_Loading = _resolveComponent("Loading");
  const _component_van_switch = _resolveComponent("van-switch");
  const _component_right = _resolveComponent("right");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container_box", {
      light: _ctx.isLightTheme,
      dark: !_ctx.isLightTheme
    }])
  }, [_createVNode(_component_Popup, {
    position: "right",
    show: _ctx.showMenu,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => _ctx.showMenu = $event),
    style: {
      width: '284px'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_left, null, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["chatBar", {
          light: _ctx.isLightTheme,
          dark: !_ctx.isLightTheme
        }])
      }, [_createElementVNode("div", {
        class: "startBtn",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.newTalk && _ctx.newTalk(...args))
      }, _hoisted_2), _createElementVNode("div", _hoisted_3, [_ctx.logList.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(item.isActive ? 'isActive logBox' : 'logBox')
        }, [item.createdTime != '' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.createdTime), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", {
          class: "chatTopic",
          onClick: $event => _ctx.getLog(item.conversationId, item.chatTopic)
        }, _toDisplayString(_ctx.stripHtmlTags(item.chatTopic)), 9, _hoisted_8)])], 2);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("img", {
        src: _ctx.isLightTheme ? require('./images/empty2.png') : require('./images/empty.png'),
        alt: "Your Image"
      }, null, 8, _hoisted_10), _hoisted_11]))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
        src: $data.imgpath.user,
        alt: "avatar"
      }, null, 8, _hoisted_14), _createElementVNode("span", null, _toDisplayString(_ctx.userName || "游客"), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        src: $data.imgpath.feedback,
        alt: "",
        style: {}
      }, null, 8, _hoisted_18), _createElementVNode("a", {
        href: _ctx.feedbackHref,
        target: "_blank"
      }, " 点此意见反馈 ", 8, _hoisted_19)]), _hoisted_20, _ctx.isLeftNav ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "logout",
        onClick: _cache[1] || (_cache[1] = (...args) => _ctx.logout && _ctx.logout(...args))
      }, "退出登录")) : _createCommentVNode("", true)])])])], 2)]),
      _: 1
    })]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_right, null, {
    default: _withCtx(() => [_createElementVNode("header", null, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("img", {
      alt: "MedsciAI",
      src: $data.imgpath.logo
    }, null, 8, _hoisted_23), _hoisted_24]), _createElementVNode("img", {
      class: "betaImg",
      src: $data.imgpath.beta,
      alt: ""
    }, null, 8, _hoisted_25)]), _createElementVNode("img", {
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.openMenu && _ctx.openMenu(...args)),
      class: "openBtn",
      src: $data.imgpath.open,
      alt: ""
    }, null, 8, _hoisted_26)]), _createElementVNode("main", _hoisted_27, [_createElementVNode("section", _hoisted_28, [_ctx.isShow && _ctx.messageList.length <= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
      class: "titleBox",
      innerHTML: _ctx.highlightText
    }, null, 8, _hoisted_31), _hoisted_32]), _ctx.filterList.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterList, item => {
      return _openBlock(), _createElementBlock("div", {
        class: "qItemBox",
        key: item.id
      }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(item.tagName), 1), _createElementVNode("div", {
        class: "editBox",
        onClick: $event => _ctx.editBtn(item.chatTemplate)
      }, [_createElementVNode("img", {
        src: $data.imgpath.edit
      }, null, 8, _hoisted_38), _hoisted_39], 8, _hoisted_37)]), _createElementVNode("span", {
        class: "qBottom",
        innerHTML: item.chatFormatTemplate
      }, null, 8, _hoisted_40)]);
    }), 128))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.messageList.length ? (_openBlock(), _createElementBlock("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "contextStyle"
      }, [item.chatType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", null, [_createElementVNode("img", {
        src: _ctx.avatar,
        alt: "avatar",
        class: "avatar"
      }, null, 8, _hoisted_43)]), _createElementVNode("div", {
        style: {
          "line-height": "20px",
          "margin-top": "4px"
        },
        innerHTML: item.message
      }, null, 8, _hoisted_44)])) : (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", null, [_createElementVNode("img", {
        src: $data.imgpath.robot,
        alt: "resAvatar",
        class: "avatar"
      }, null, 8, _hoisted_46)]), item.message == 'loading' ? (_openBlock(), _createBlock(_component_Loading, {
        key: 0,
        color: "#1989fa"
      })) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        innerHTML: item.message,
        style: {
          "line-height": "22px",
          "word-break": "break-word"
        }
      }, null, 8, _hoisted_47))]))]);
    }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_48, [_withDirectives(_createElementVNode("textarea", {
      class: _normalizeClass([{
        textareaStyle: _ctx.contextDisable
      }, "chatInput"]),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.message = $event),
      rows: "1",
      placeholder: _ctx.messageList.length ? '发消息给小智' : '请输入您想了解的内容，输入“/”可获取提问模板',
      maxlength: "1024",
      readonly: _ctx.contextDisable,
      onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers((...args) => _ctx.sendMessage && _ctx.sendMessage(...args), ["exact", "prevent"]), ["enter"]))
    }, null, 42, _hoisted_49), [[_vModelText, _ctx.message]]), _ctx.messageList && _ctx.messageList.length == 0 || _ctx.message ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: _normalizeClass([{
        textareaStyle: _ctx.contextDisable
      }, "chatButton"]),
      disabled: _ctx.contextDisable,
      onClick: _cache[6] || (_cache[6] = $event => _ctx.sendMessage())
    }, [_createElementVNode("img", {
      src: $data.imgpath.send,
      alt: "icon",
      class: "sendBtn"
    }, null, 8, _hoisted_51)], 10, _hoisted_50)) : (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: _normalizeClass([{
        textareaStyle: _ctx.contextDisable
      }, "chatButton"]),
      disabled: _ctx.contextDisable,
      onClick: _cache[7] || (_cache[7] = $event => _ctx.reloadMessage())
    }, [_createElementVNode("img", {
      src: $data.imgpath.refresh,
      alt: "icon",
      class: "refreshBtn"
    }, null, 8, _hoisted_53)], 10, _hoisted_52))])]), _createElementVNode("footer", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createVNode(_component_van_switch, {
      modelValue: _ctx.isLightTheme,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.isLightTheme = $event),
      size: "13px",
      "inactive-color": "#858585",
      "active-color": "#D1E7FF",
      class: _normalizeClass(_ctx.isLightTheme ? _ctx.lights : _ctx.darks)
    }, null, 8, ["modelValue", "class"]), _hoisted_57]), _hoisted_58])])]),
    _: 1
  })], 2);
}